module.exports = __webpack_public_path__ + "img/survey-icon.0f7fbe5e.png";